import { PureComponent } from 'react';

import { debounce } from '@codex-brightworld/helpers';

type ChildrenFuncArgs = {
  filter: (searchTerm: string) => void;
  filtering: boolean;
  filteredItems: any[];
  searchTerm: string;
  valid: boolean;
};

type Props = {
  debounce: number;
  items: unknown[];
  searchTermRegExp: string;
  /**
   * @param {array} items
   * @param {string} searchTerm
   * @return {array}
   */
  filterHandler: (items: unknown[], searchTerm: string) => unknown[];
  /**
   * @param {Object} renderProps
   * @param {function} renderProps.filter
   * @param {boolean} renderProps.filtering
   * @param {Array} renderProps.filteredItems
   * @param {string} renderProps.searchTerm
   * @param {boolean} renderProps.valid
   * @return {React.Node}
   */
  children: (args: ChildrenFuncArgs) => JSX.Element;
};

export class Filter extends PureComponent<Props> {
  public static displayName = 'Filter';

  private validationRegExp = new RegExp(this.props.searchTermRegExp, 'i');

  public static defaultProps = {
    debounce: 300,
    searchTermRegExp: '^[0-9A-Z.&-/"s]*$'
  };

  public state = {
    searchTerm: '',
    filtering: false,
    filteredItems: this.props.items,
    valid: true
  };

  private debouncedFilter: any;

  public componentDidMount() {
    this.debouncedFilter = debounce(this.onFilter, this.props.debounce);
  }

  private onFilter = (searchTerm: string) => {
    this.setState({
      searchTerm,
      filtering: false,
      filteredItems: this.props.filterHandler(this.props.items, searchTerm)
    });
  };

  private validate = (searchTerm: string) => this.validationRegExp.test(searchTerm);

  private filter = (searchTerm: string) => {
    const valid = this.validate(searchTerm);

    this.setState({ filtering: valid, valid });
    this.debouncedFilter(searchTerm);
  };

  public render() {
    const { props, state } = this;

    return props.children({
      filter: this.filter,
      filtering: state.filtering,
      filteredItems: state.filteredItems,
      searchTerm: state.searchTerm,
      valid: state.valid
    });
  }
}
